// import React from 'react';
// import PropTypes from 'prop-types';
// import { Container, Segment, Header, List } from 'semantic-ui-react';

// const Result = ({ questionsAndAnswers }) => {
//   console.log("resuşt patfge quesntions and answers: " + JSON.stringify(questionsAndAnswers))
//   return (
//     <Container style={{ marginTop: 30 }}>
//       <Header as="h1" textAlign="center">Test Sonuçları</Header>
//       {questionsAndAnswers.map((item, index) => (
//         <Segment key={index}>
//           <Header as="h3">{item.question}</Header>
//           <List bulleted>
//             {item.selectedTexts.map((text, i) => (
//               <List.Item key={i}>{text}</List.Item>
//             ))}
//           </List>
//         </Segment>
//       ))}
//     </Container>
//   );
// };

// Result.propTypes = {
//   questionsAndAnswers: PropTypes.array.isRequired,
// };

// export default Result;














// src/components/Result.js

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Container, Menu, Message } from 'semantic-ui-react';

import Stats from './Stats';
import QNA from './QNA';
import Details from './Details';

const Result = ({
  totalQuestions = 0,
  resultType = '',
  resultName = '',
  questionsAndAnswers = [],
  userInfo = {},
  replayQuiz,
  resetQuiz,
}) => {
  const [activeTab, setActiveTab] = useState('İstatistik');

  const handleTabClick = (e, { name }) => {
    setActiveTab(name);
  };

  const renderContent = () => {
    if (activeTab === 'İstatistik') {
      return (
        <Stats
          totalQuestions={totalQuestions}
          resultType={resultType}
          resultName={resultName}
          replayQuiz={replayQuiz}
          resetQuiz={resetQuiz}
          userInfo={userInfo}
        />
      );
    }

    if (activeTab === 'Sorular') {
      return questionsAndAnswers.length > 0 ? (
        <QNA questionsAndAnswers={questionsAndAnswers} />
      ) : (
        <Message warning content="Soru-cevap verisi bulunamadı." />
      );
    }

    if (activeTab === 'Kişilik') {
      return resultType ? (
        <Details userInfo={userInfo} resultType={resultType} resultName={resultName} />
      ) : (
        <Message warning content="Sonuç tipi belirlenemedi." />
      );
    }

    return null;
  };

  return (
    <Container style={{ marginTop: 30 }}>
      <Menu fluid widths={3} pointing secondary>
      <Menu.Item
  name="İstatistik"
  active={activeTab === 'İstatistik'}
  onClick={handleTabClick}
  content="İstatistik"
/>
<Menu.Item
  name="Sorular"
  active={activeTab === 'Sorular'}
  onClick={handleTabClick}
  content="Yanıtlar"
/>
<Menu.Item
  name="Kişilik"
  active={activeTab === 'Kişilik'}
  onClick={handleTabClick}
  content="Kişilik Detayı"
/>

      </Menu>

      {renderContent()}
    </Container>
  );
};

Result.propTypes = {
  totalQuestions: PropTypes.number,
  resultType: PropTypes.string,
  questionsAndAnswers: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      selectedTexts: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  replayQuiz: PropTypes.func.isRequired,
  resetQuiz: PropTypes.func.isRequired,
};

export default Result;
